import { Trans } from '@lingui/react/macro';
import { Clock } from '@untitledui/icons/Clock';
import { CreditCard02 } from '@untitledui/icons/CreditCard02';
import { HelpCircle } from '@untitledui/icons/HelpCircle';

import { Tooltip, TooltipTrigger } from '@/components/base/tooltip/tooltip';
import { formatStudyLength } from '@/utils/study-length';

interface ProjectMetadataRowProps {
  reward?: string;
  durationMinutes?: number;
  kindOfResearch?: number;
  isRemote?: boolean;
}

export function ProjectMetadataRow({
  reward,
  durationMinutes,
  kindOfResearch,
}: ProjectMetadataRowProps) {
  return (
    <div className="flex flex-col gap-6 md:flex-row md:items-center md:gap-10">
      {/* Reward */}
      {reward && (
        <MetadataItem
          icon={CreditCard02}
          label={<Trans>reward</Trans>}
          value={
            <div className="flex items-center gap-2">
              <span className="text-xl font-semibold text-utility-success-600">
                {reward}
              </span>

              <Tooltip
                title={
                  <Trans>
                    A 5% fulfillment fee applies to the incentive, with a $1
                    minimum.
                  </Trans>
                }
                placement="top"
              >
                <TooltipTrigger>
                  <HelpCircle className="size-5 cursor-help text-tertiary" />
                </TooltipTrigger>
              </Tooltip>
            </div>
          }
        />
      )}

      {/* Duration */}
      {durationMinutes !== undefined && (
        <MetadataItem
          icon={Clock}
          label={<Trans>duration</Trans>}
          value={
            <span className="text-lg font-semibold text-primary">
              {formatStudyLength(durationMinutes, kindOfResearch)}
            </span>
          }
        />
      )}
    </div>
  );
}

interface MetadataItemProps {
  icon: React.ComponentType<{ className?: string }>;
  label: React.ReactNode;
  value: React.ReactNode;
}

function MetadataItem({ icon: Icon, label, value }: MetadataItemProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Icon className="size-6 text-secondary" />
        <span className="text-sm font-medium text-secondary">{label}</span>
      </div>
      {value}
    </div>
  );
}
